import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Badge } from '../ui/badge';
import { nominationAPI, STATUS_TONE } from '../../lib/atoNominationAPI';
import { errText, auDate } from '../../lib/complianceAutoAPI';
import { VerifyForm, LinkForm } from './ClientNominationTab';
import { ReportEvidence } from './NominationR2Panels';

export const NominationVerifyDialog = ({ nominationId, clientId, onClose }) => {
  const [data, setData] = useState(null);
  const load = useCallback(() => nominationAPI.client(clientId).then(setData).catch((e) => toast.error(errText(e))), [clientId]);
  useEffect(() => { if (nominationId) load(); }, [nominationId, load]);
  const r = data?.records.find((x) => x.id === nominationId);
  const act = async (action, body) => { try { await nominationAPI.act(nominationId, action, body); toast.success('Saved'); load(); } catch (e) { toast.error(errText(e)); } };
  return (
    <Dialog open={!!nominationId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="nom-verify-dialog">
        <DialogHeader><DialogTitle>Verify ATO agent nomination</DialogTitle></DialogHeader>
        {r && <div className="space-y-3 text-sm">
          <div className="flex flex-wrap items-center gap-2"><b>{r.client_name}</b><span className="text-xs text-muted-foreground">ABN {r.abn_masked || '—'}</span>
            <Badge className={STATUS_TONE[r.status]} data-testid="nom-verify-dialog-status">{r.status_label}</Badge></div>
          <div className="text-xs text-muted-foreground">Client nomination date {auDate(r.nomination_date)} · expiry {auDate(r.expiry_date)}</div>
          <ReportEvidence r={r} />
          {['client_confirmed', 'verification_pending', 'not_found'].includes(r.status) && <VerifyForm key={`v-${r.status}`} r={r} act={act} />}
          {['nomination_verified', 'agent_linking_pending', 'linking_failed'].includes(r.status) && <LinkForm r={r} accounts={data.accounts} act={act} />}
          {['linked', 'completed'].includes(r.status) && <p className="text-emerald-700" data-testid="nom-verify-dialog-done">Linked {auDate(r.linking_date)} – {(r.linked_accounts || []).join(', ')}</p>}
        </div>}
      </DialogContent>
    </Dialog>
  );
};
